import LocalityCrud from './LocalityCrud'
export {LocalityCrud}
export default LocalityCrud
